"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./ClassificationOptionLabelWithTooltip.scss");
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _TooltipHostWrapper = require("../Shared/Components/TooltipLabel/TooltipHostWrapper");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ClassificationOptionLabelWithTooltip = function ClassificationOptionLabelWithTooltip(props) {
  return /*#__PURE__*/React.createElement(_react2.Stack, {
    tokens: {
      childrenGap: 4
    },
    className: "classification-option-label"
  }, /*#__PURE__*/React.createElement(_react2.Text, {
    variant: "medium",
    className: "choice-group-label"
  }, props.labelText, /*#__PURE__*/React.createElement(_TooltipHostWrapper.TooltipHostWrapper, {
    directionalHint: _react2.DirectionalHint.rightCenter,
    className: "ms-tooltip-host",
    content: props.tooltipText
  }, /*#__PURE__*/React.createElement(_react2.Icon, {
    iconName: "Info",
    className: "info-icon",
    role: "button",
    tabIndex: 0,
    "aria-label": "".concat(props.labelText, " ").concat(props.tooltipText)
  }))));
};
var _default = ClassificationOptionLabelWithTooltip;
exports.default = _default;